'use client';

import Link from 'next/link';

import { Button, TextArea, TextField } from '@paction-2.0/ui';

import styles from './contactPage.module.scss';
import { useContactForm } from './useContactForm';

export function ContactForm() {
  const {
    form,
    isSubmitDisabled,
    isSubmitted,
    isLoading,
    errorMessage,
    update,
    handleSubmit
  } = useContactForm();

  return (
    <section className={styles.form} id="message">
      <h2 className={styles.formTitle}>Send Us a Message</h2>
      <p className={styles.formSubtitle}>
        Fill out the form and a member of the team will reach out shortly.
      </p>
      <form onSubmit={handleSubmit} noValidate>
        <div className={[styles.row, styles.rowSplit].join(' ')}>
          <TextField
            placeholder="Full Name"
            value={form.name}
            onChange={(event) => update('name', event.target.value)}
          />
          <TextField
            type="email"
            placeholder="Email"
            value={form.email}
            onChange={(event) => update('email', event.target.value)}
          />
        </div>
        <div className={styles.row}>
          <TextField
            type="tel"
            placeholder="Phone (optional)"
            value={form.phone}
            onChange={(event) => update('phone', event.target.value)}
          />
        </div>
        <div className={styles.row}>
          <TextArea
            placeholder="How can we help?"
            rows={5}
            maxLength={1200}
            value={form.message}
            onChange={(event) => update('message', event.target.value)}
          />
        </div>

        {errorMessage ? (
          <div className={[styles.status, styles.statusError].join(' ')}>
            {errorMessage}
          </div>
        ) : null}

        {isSubmitted && !errorMessage ? (
          <div className={[styles.status, styles.statusSuccess].join(' ')}>
            Thanks for reaching out! A member of the Paction team will email you
            within one business day—keep an eye on your inbox and spam folder.
          </div>
        ) : null}

        <div className={styles.actions}>
          <Button type="submit" disabled={isSubmitDisabled || isLoading}>
            Send Message
          </Button>
        </div>

        <p className={styles.disclaimer}>
          By submitting this form you agree to our{' '}
          <Link href="/terms-of-service">Terms of Service</Link> and{' '}
          <Link href="/privacy-policy">Privacy Policy</Link>.
        </p>
      </form>
    </section>
  );
}
